module.exports = __webpack_public_path__ + "static/media/loader.1a7273f0.gif";